import { IDI_CALENDAR_SEARCH_START_LOADING, IDI_CALENDAR_SEARCH_END_LOADING, IDI_CALENDAR_SEARCH_LOADED, SET_IDI_CALENDAR_FILTER } from "../constants/IdiCalendarConstants";

const initialState = {
    loading: false,
    fbo: null,
    filter: {
        search: ""
    }
};

const IdiCalendarReducer = (state = initialState, action) => {
    switch(action.type) {
        case IDI_CALENDAR_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case IDI_CALENDAR_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case IDI_CALENDAR_SEARCH_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        case SET_IDI_CALENDAR_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        default:
            return state;
    }
}

export default IdiCalendarReducer;
